module.exports = {"root":{"abstract":true,"use":"root"}}